export default __webpack_public_path__ + "static/media/new8.0f75852d.jpg";